module.exports = __webpack_public_path__ + "img/lines-single-start.c80ca702.png";